import { REQUESTED, ACTIVATED, REJECTED } from 'constants/AddOns';

export function iconForStatus(status) {
  switch (status) {
    case ACTIVATED:
      return {
        icon: 'check-circle',
        color: 'green'
      };
    case REJECTED:
      return {
        icon: 'times-circle',
        color: 'red'
      }
    case REQUESTED:
      return {
        icon: 'exclamation-triangle',
        color: '#FCBB43'
      };
  }
}


// WEBPACK FOOTER //
// ./src/utils/addOnHelpers.js